import { render, staticRenderFns } from "./PhoneFooter.vue?vue&type=template&id=17450997&scoped=true&"
import script from "./PhoneFooter.vue?vue&type=script&lang=js&"
export * from "./PhoneFooter.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFooter.vue?vue&type=style&index=0&id=17450997&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17450997",
  null
  
)

export default component.exports